import React, { useMemo } from 'react'

import CustomizeEmbed from 'Pods/LazyLoaded/ShareModal/Components/CustomizeEmbed'
import EmbedSection from 'Pods/LazyLoaded/ShareModal/Components/EmbedSection'
import Preview from 'Pods/LazyLoaded/ShareModal/Components/Preview'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import slugifyTitle from 'Pods/ThreeDStudio/Shared/Utils/slugifyTitle'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

const EMBED_BUTTON_LABEL = 'Embed this 3D Model'

function ThreeDStudioShareContent() {
  const pageConfig = usePageConfig()
  const sharerUsername = pageConfig?.currentUserUsername || ''

  const runId = useThreeDStudioStore(state => state.ui?.openedModel?.id)
  const runTitle = useThreeDStudioStore(
    state => state.ui?.openedModel?.title ?? state.ui?.openedModel?.prompt ?? ''
  )

  const embedUrl = useMemo(
    () => `${window.location.origin}/embed/ai/${runId}`,
    [runId]
  )

  const shareUrl = useMemo(
    () => `${window.location.origin}/ai/3d-models/${slugifyTitle(runTitle)}-${runId}`,
    [runId, runTitle]
  )

  return (
    <EmbedSection
      shareUrl={shareUrl}
      renderCustomize={(settings, onSettingsChange) => (
        <CustomizeEmbed
          embedUrl={embedUrl}
          embedButtonLabel={EMBED_BUTTON_LABEL}
          sharerUsername={sharerUsername}
          settings={settings}
          onSettingsChange={onSettingsChange}
        />
      )}
      renderPreview={(settings) => (
        <Preview
          settings={settings}
          sharerUsername={sharerUsername}
          embedUrl={embedUrl}
        />
      )}
    />
  )
}

export default ThreeDStudioShareContent
